import { Client, Account, Databases, Storage, Messaging } from 'appwrite';

const client = new Client();

client
    .setEndpoint(`${process.env.REACT_APP_APPWRITE_ENDPOINT}`)
    .setProject(`${process.env.REACT_APP_APPWRITE_PROJECT_ID}`);


export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export const messaging = new Messaging(client);

export default client;